function gcInitReveal() {
  const els = document.querySelectorAll('.gc-reveal');
  if (!els.length) return;
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('gc-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => io.observe(el));
}

function gcInitStaggerIndexes() {
  document.querySelectorAll('.gc-reveal-stagger').forEach((wrap) => {
    Array.from(wrap.children).forEach((child, i) => {
      child.style.setProperty('--gc-i', i);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  gcInitStaggerIndexes();
  gcInitReveal();
});
